import { StoreApi, UseBoundStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { MeetingStore } from '@/store/meetingStore';

type GenericState = MeetingStore;

export const createStoreWithSelectors = <T extends GenericState>(
  store: UseBoundStore<StoreApi<T>>,
): (<K extends keyof T>(keys: K[]) => Pick<T, K>) => {
  return <K extends keyof T>(keys: K[]) => {
    return store(
      useShallow((state) => {
        const x = keys.reduce((acc, cur) => {
          acc[cur] = state[cur];
          return acc;
        }, {} as T);

        return x as Pick<T, K>;
      }),
    );
  };
};
